var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5965",
    "data-name": "Group 5965",
    transform: "translate(10413 -5838)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-10413 5838)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dollar-symbol_1_",
    "data-name": "dollar-symbol(1)",
    transform: "translate(-10408 5843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M10.222,0A10.222,10.222,0,1,0,20.445,10.222,10.222,10.222,0,0,0,10.222,0Zm.619,14.776v1.183a.317.317,0,0,1-.329.319H9.724a.321.321,0,0,1-.334-.319V14.88a6.771,6.771,0,0,1-2.013-.4.632.632,0,0,1-.388-.747l.129-.5a.632.632,0,0,1,.841-.432,5.076,5.076,0,0,0,1.818.353c.848,0,1.428-.327,1.428-.923,0-.565-.476-.923-1.577-1.295C8.035,10.4,6.945,9.657,6.945,8.213A2.753,2.753,0,0,1,9.455,5.565V4.485a.355.355,0,0,1,.343-.35h.789a.337.337,0,0,1,.321.35V5.46a5.874,5.874,0,0,1,1.611.269.634.634,0,0,1,.42.758l-.113.448a.631.631,0,0,1-.817.441,4.556,4.556,0,0,0-1.5-.249c-.967,0-1.28.417-1.28.834,0,.491.521.8,1.786,1.28,1.771.625,2.482,1.444,2.482,2.782A2.851,2.851,0,0,1,10.841,14.776Z",
    fill: "#3f2566"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmount);
export default __webpack_public_path__ + "static/media/Amount.646a2a7932bad371900f36746550069a.svg";
export { ForwardRef as ReactComponent };